import React, { useMemo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import EnvironmentManager from 'Utils/environmentManager';
import mixpanel from 'Utils/mixpanel';

const PredictaCampaignModal = ({ calculatedProbability }) => {
  const { targetProbability = 0, bonusRatio = 0 } = useSelector(
    ({ userCampaign }) => userCampaign?.predictaBonusCampaign?.data ?? {}
  );
  useEffect(() => {
    mixpanel.track('View Predicta Bonus Popup', {
      'Predicta Percentage': calculatedProbability ? calculatedProbability : '0'
    });
  }, [calculatedProbability]);

  const predictaCampaignMassSwitch = EnvironmentManager.getMessageText({ key: 'predicta_bonus_whole_mass_toogle' }) === 'true';
  const predictaPercentage = parseFloat(EnvironmentManager.getMessageText({ key: 'predicta_bonus_whole_mass_predicta_percentage' })) * 100;
  const bonusPercentage = parseFloat(EnvironmentManager.getMessageText({ key: 'predicta_bonus_whole_mass_bonus_percentage' })) * 100;

  const avatarSrc = useMemo(
    () => EnvironmentManager.getMessageText({ key: 'predicta_bonus_popup_image' }),
    []
  );
  const title = useMemo(
    () => EnvironmentManager.getMessageText({ key: 'predicta_bonus_popup_title' }),
    []
  );
  const textTemplate = useMemo(
    () => EnvironmentManager.getMessageText({ key: 'predicta_bonus_popup_text' }),
    []
  );

  const formattedText = useMemo(() => {
    const probabilityPercent = Math.round(targetProbability * 100);
    const bonusPercent = Math.round(bonusRatio * 100);
    const displayProbabilityPercent = predictaCampaignMassSwitch ? predictaPercentage : probabilityPercent;
    const displayBonusPercent = predictaCampaignMassSwitch ? bonusPercentage : bonusPercent;

    return textTemplate
      .replace('%@', `%${displayProbabilityPercent}`)
      .replace('%@', `%${displayBonusPercent}`);
  }, [textTemplate, targetProbability, bonusRatio, predictaCampaignMassSwitch, predictaPercentage, bonusPercentage]);

  if (!textTemplate) {
    return null;
  }

  return (
    <>
      <div className="predicta-campaign-popup">
        <img
          className="predicta-campaign-popup__img"
          src={ avatarSrc }
          alt="Predicta Bonus"
        />
      </div>
      <p className="predicta-campaign-popup__title">{ title }</p>
      <span className="predicta-campaign-popup__text">{ formattedText }</span>
    </>
  );
};

PredictaCampaignModal.propTypes = {
  calculatedProbability: PropTypes.string
};

PredictaCampaignModal.defaultProps = {
  calculatedProbability: '0'
};

export default React.memo(PredictaCampaignModal);
